export const SystemLogsPage = () => {
  return <></>;
};
